@for (response of responses; track response) {
<div>
  <span>{{ response.question }}:</span>
  @if (responses.length > 16) {
  <br />
  }
  {{ response.response }}
</div>
}
